import { Box } from '@mui/material';
import Image from 'next/image';

interface AuthorAvatarProps extends React.ComponentProps<typeof Image> {
  sizeVariant?: 'small' | 'medium' | 'large' | 'extraLarge';
}

const sizeMap = {
  small: 35,
  medium: 40,
  large: 55,
  extraLarge: 65,
};

export const AuthorAvatar = ({ sizeVariant = 'small', ...props }: AuthorAvatarProps) => {
  const size = sizeMap[sizeVariant];

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'neutral.lighter',
      }}
    >
      <Image
        {...props}
        width={size}
        height={size}
        style={{
          objectFit: 'cover',
          objectPosition: 'top center',
        }}
        unoptimized
      />
    </Box>
  );
};
